import React, { useEffect, useState, useContext } from 'react';
import LeadsSection from './LeadsSection';
import { useActionsContext } from '../../context/ActionsContext';
import LeadItem from './LeadItem';
import DefaultModal from '../../components/modals/DefaultModal';
import { Close } from '@material-ui/icons';
import AddLead from './AddLead';
import Localbase from 'localbase';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import axios from 'axios';
import ENDPOINT from '../../context/EndPoint';
import SecurityHeaders from '../../context/SecurityHeaders';
import { AuthContext } from '../../context/AuthContext';
import { use } from 'react';

const LeadsPage = () => {
  let db = new Localbase('db');
  const { leads, fetchLeads, permission, username, Addition, internalteamlist, fetchInternalTeamList } = useActionsContext();
  const { user } = useContext(AuthContext);
  const [addlead, setAddLead] = useState(false);
  const [leadsData, setLeadsData] = useState(null);
const { rowsPerPage, setRowsPerPage } = useActionsContext(); 


  useEffect(() => {
    fetchInternalTeamList({ payload: {} });
    fetchLeads();
    Addition();
  }, [rowsPerPage]);

  useEffect(() => {
    if (leads && leads.data) {
      setLeadsData(leads.data);
    }
  }, [leads]);

  const Reload = () => {
    fetchLeads();
  };

  const onDragEnd = async (result) => {
    if (!result.destination || !leadsData || !user) return;

    const { source, destination } = result;
    const sourceCategory = source.droppableId;
    const destCategory = destination.droppableId;

    let newLeadsData = { ...leadsData };

    // Handle drag within the same category
    if (sourceCategory === destCategory) {
      const categoryLeads = Array.from(newLeadsData[sourceCategory]);
      const [movedLead] = categoryLeads.splice(source.index, 1);
      categoryLeads.splice(destination.index, 0, movedLead);
      newLeadsData[sourceCategory] = categoryLeads;
    } else {
      // Handle drag to a different category
      const sourceLeads = Array.from(newLeadsData[sourceCategory]);
      const destLeads = Array.from(newLeadsData[destCategory]);
      const [movedLead] = sourceLeads.splice(source.index, 1);
      destLeads.splice(destination.index, 0, { ...movedLead, category: destCategory });
      newLeadsData[sourceCategory] = sourceLeads;
      newLeadsData[destCategory] = destLeads;
    }

    setLeadsData(newLeadsData);

    // Prepare data for backend update
    const updatedLeads = [];
    Object.keys(newLeadsData).forEach((category) => {
      newLeadsData[category].forEach((lead, index) => {
        updatedLeads.push({ id: lead.id, category, order: index + 1 });
      });
    });

    // Send update to backend
    try {
      const formData = new FormData();
      formData.append('session', user.SessionId);
      formData.append('leads', JSON.stringify(updatedLeads));
      const res = await axios.post(`${ENDPOINT}update-lead-order.php`, formData, SecurityHeaders);
      if (res.data.status !== 'success') {
        console.error('Order update failed:', res.data.message);
        Reload(); // Revert to original order on failure
      }
    } catch (err) {
      console.error('Error updating lead order:', err.message);
      Reload(); // Revert on error
    }
  };

  const categories = [
    { id: 'demo_scheduled', title: 'Demo Scheduled', permission: 'view_scheduled_leads', bg: 'bg-danger-subtle', value: '$265,200', deals: '4 Deals' },
    { id: 'interested', title: 'Interested', permission: 'view_interested_leads', bg: 'bg-success-subtle', value: '$108,700', deals: '5 Deals' },
    { id: 'not_interested', title: 'Not Interested', permission: 'view_not_interested_leads', bg: 'bg-warning-subtle', value: '$708,200', deals: '7 Deals' },
    { id: 'joined', title: 'Joined', permission: 'view_joined_leads', bg: 'bg-info-subtle', value: '$44,900', deals: '3 Deals' },
    { id: 'pending_payment', title: 'Pending Payment', permission: 'view_pending_payment_leads', bg: 'bg-secondary-subtle', value: '$819,300', deals: '8 Deals' },
  ];


  const [count, setCount] = useState(0);

  return (
    <>
      <DefaultModal
        show={addlead}
        HandleClose={() => setAddLead(false)}
        content={
          <div className="p-2">
            <div className="modal-header">
              <h4>Add Lead</h4>
              <Close onClick={() => setAddLead(false)} />
            </div>
            <hr />
            <AddLead Reload={Reload} />
          </div>
        }
      />




      <div className="container-fluid">
        <div className="card">
          <div className="card-body">
            <div className="row g-3">
              <div className="col-md-3">
                <div className="search-box">
                  <input
                    type="text"
                    className="form-control search"
                    placeholder="Search for deals..."
                  />
                  <i className="ri-search-line search-icon" />
                </div>
              </div>
              <div className="col-md-auto ms-auto">
                <div className="d-flex hastck gap-2 flex-wrap">
                  <div className="d-flex align-items-center gap-2">
                    <span className="text-muted">Sort by: </span>
                    <select
                      className="form-control mb-0"
                      data-choices=""
                      data-choices-search-false=""
                      id="choices-single-default"
                    >
                      <option value="Owner">Owner</option>
                      <option value="Company">Company</option>
                      <option value="Date">Date</option>
                    </select>
                  </div>
                  <button onClick={() => setAddLead(true)} className="btn btn-success">
                    <i className="ri-add-fill align-bottom me-1" /> Add Lead
                  </button>
                  <div className="dropdown">
                    <button
                      className="btn btn-soft-info btn-icon fs-14"
                      type="button"
                      id="dropdownMenuButton1"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <i className="ri-settings-4-line" />
                    </button>
                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                      <li><a className="dropdown-item" href="#">Copy</a></li>
                      <li><a className="dropdown-item" href="#">Move to pipeline</a></li>
                      <li><a className="dropdown-item" href="#">Add to exceptions</a></li>
                      <li><a className="dropdown-item" href="#">Switch to common form view</a></li>
                      <li><a className="dropdown-item" href="#">Reset form view to default</a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {leadsData && (
          <DragDropContext onDragEnd={onDragEnd}>
            <div className="row row-cols-xxl-5 row-cols-lg-3 row-cols-md-2 row-cols-1">
              {categories.map((category) =>
                parseInt(permission[category.permission]) ? (
                  <div className="col" key={category.id}>
                    <div className="card">
                      <a
                        className={`card-body ${category.bg}`}
                        data-bs-toggle="collapse"
                        href={`#${category.id}`}
                        role="button"
                        aria-expanded="false"
                        aria-controls={category.id}
                      >
                        <h5 className="card-title text-uppercase fw-semibold mb-1 fs-15">
                          {category.title}
                        </h5>
                        <p className="text-muted mb-0">
                          {category.value} <span className="fw-medium">{category.deals}</span>
                        </p>
                      </a>
                    </div>
                    <Droppable droppableId={category.id}>
                      {(provided) => (
                        <div
                          className="collapse show"
                          id={category.id}
                          ref={provided.innerRef}
                          {...provided.droppableProps}
                        >
                          {leadsData[category.id]?.map((item, index) => (
                            <LeadItem
                              key={item.id}
                              index={index}
                              item={item}
                              Reload={Reload}
                            />
                          ))}
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  </div>
                ) : null
              )}
            </div>
          </DragDropContext>
        )}
      </div>
    </>
  );
};

export default LeadsPage;